import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_tenant_sms_portal_settings: { message: "idle" },
};

export const retrieve_tenant_sms_portal_settings_Slice = createSlice({
 name: "retrieve_tenant_sms_portal_settings",
 initialState,
 reducers: {
  success_retrieve_tenant_sms_portal_settings: (state, action) => {
   state.retrieve_tenant_sms_portal_settings = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_tenant_sms_portal_settings: (state, action) => {
   state.retrieve_tenant_sms_portal_settings = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_tenant_sms_portal_settings: (state) => {
   state.retrieve_tenant_sms_portal_settings = { status: app_consts.IDLE };
  },
  loading_retrieve_tenant_sms_portal_settings: (state) => {
   state.retrieve_tenant_sms_portal_settings = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_tenant_sms_portal_settings, fail_retrieve_tenant_sms_portal_settings, reset_retrieve_tenant_sms_portal_settings, loading_retrieve_tenant_sms_portal_settings } = retrieve_tenant_sms_portal_settings_Slice.actions;

export default retrieve_tenant_sms_portal_settings_Slice.reducer;